// extracted by mini-css-extract-plugin
module.exports = {"power-independence-C":"C_power-independence-C__uJkfH"};